import { format } from 'date-fns'
import { TZDate } from '@date-fns/tz'

// Дельта после бронирования, в течение которой ученик может отменить
// занятие с возвратом средств — даже если до начала осталось меньше суток
// (например, забронировали занятие на завтрашнее утро поздно вечером)
export const CANCEL_GRACE_MINUTES = 30

// Причина недоступности отмены для ученика (tooltip/disabledReason)
export const CANCEL_STUDENT_REASON =
	'Занятие можно отменить не позднее чем за день до начала или в течение 30 минут после бронирования'

/**
 * Можно ли отменить занятие.
 * Преподаватель — всегда. Ученик — не позднее чем за день до начала занятия,
 * либо в течение CANCEL_GRACE_MINUTES после бронирования (created_at занятия).
 */
export const canCancelLesson = ({
	status,
	startsAt,
	createdAt,
	timezone,
	isTeacher = false,
	now = new Date(),
}) => {
	if (status !== 'active') return false
	if (isTeacher) return true

	// Грейс-период после бронирования: отмена с возвратом средств
	const created = createdAt ? new Date(createdAt) : null
	if (created && !Number.isNaN(created.getTime())) {
		const diffMs = now.getTime() - created.getTime()
		if (diffMs < CANCEL_GRACE_MINUTES * 60 * 1000) return true
	}

	// Данные ещё грузятся — не блокируем кнопку
	if (!startsAt || !timezone) return true

	// Строки yyyy-MM-dd сравниваются лексикографически корректно
	const dayKey = format(new TZDate(startsAt, timezone), 'yyyy-MM-dd')
	const todayKey = format(new TZDate(now, timezone), 'yyyy-MM-dd')
	return dayKey > todayKey
}
